import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CreateBackgroundIdentificationItemTemplate } from 'works/legacy/graphql/works-list-item-template';
import DocumentTemplateForm from './document-template-form';
import { addErrorsToForm } from 'works/legacy/lib/form-helpers';

export default function CreateBackgroundIdentificationTemplate({
  dismiss,
  worksListTemplateId,
  form,
}) {
  const handleMutationCompletion = (response) => {
    if (response.createBackgroundIdentificationItemTemplate.errors) {
      addErrorsToForm(
        form,
        response.createBackgroundIdentificationItemTemplate.errors
      );

      createMessage(
        'error',
        'Failed to update Compliance Item. Please try again.'
      );
    } else {
      createMessage('success', 'Compliance Item created!');
      dismiss();
    }
  };

  const [createBackgroundIdentification] = useMutation(
    CreateBackgroundIdentificationItemTemplate,
    {
      onCompleted: handleMutationCompletion,
      onError: () =>
        createMessage(
          'error',
          'Failed to create Compliance Item. Please try again.'
        ),
    }
  );

  const handleSubmit = (values) => {
    createBackgroundIdentification({
      variables: {
        worksListTemplateId: worksListTemplateId,
        input: values,
      },
    });
  };

  return (
    <DocumentTemplateForm
      categories={['background', 'identity', 'facility_required']}
      dismiss={dismiss}
      handleSubmit={handleSubmit}
      initialValues={{ active: true, expirationType: 'EXPIRATION_DATE' }}
      showExpiration
      form={form}
    />
  );
}

CreateBackgroundIdentificationTemplate.propTypes = {
  dismiss: PropTypes.func.isRequired,
  worksListTemplateId: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
};
